import { API } from '../config/config';

let _cacheCategorias = null;
let _cacheTimeCategorias = 0;
const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutos

const invalidateCache = () => {
  _cacheCategorias = null;
  _cacheTimeCategorias = 0;
};

const CategoriaService = {
  getAll: () => getCategorias(),
  create: async (data) => {
    try {
      const response = await API.post('/categories', data);
      invalidateCache();
      return response.data;
    } catch (err) {
      console.error('Error creating category:', err);
      throw err;
    }
  },
};

const getCategorias = async () => {
  const now = Date.now();
  if (_cacheCategorias && (now - _cacheTimeCategorias) < CACHE_TTL_MS) {
    return _cacheCategorias;
  }
  try {
    const response = await API.get('/categories');
    _cacheCategorias = response.data;
    _cacheTimeCategorias = now;
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err);
  }
};

export default CategoriaService;
